import { render, staticRenderFns } from "./SpecsChart.vue?vue&type=template&id=72022fc6"
import script from "./SpecsChart.vue?vue&type=script&lang=js"
export * from "./SpecsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports